import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from './global.service';
import { WindowRef } from '../_helpers/window.ref';
import { Location } from '@angular/common';
import { ConsoleColors } from '../_enums/consoleColors.enum';

@Injectable()
export class NavigationService {

    private _routes: Array < any > = null;
    tabbingDebouncerTimeout: any = null;
    private _currentStep: number;
    private _scrollToTopTimeout: any = null;

    constructor(
        private globalService: GlobalService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location
    ) {
        console.debug('NavigationService().constructor()');
    }

    initRoutes(routeConfigChildren) {
        let rcc = [];
        for (let i = 0, len = routeConfigChildren.length; i < len; i++) {
            let item = routeConfigChildren[i];
            if (item.path !== "" && item.path !== "." && item.path !== "/") {
                rcc.push(item);
            }
        }
        this._routes = rcc;
        this.updateRouteIndexes();
    }

    updateRouteIndexes() {
        console.debug('\n\n1. updateRouteIndexes() ---------- navigation.service 2020-07-16_15:00:00 ----------');
        console.debug('2. this._routes: ', this._routes);

        let routeIndexes = {};
        for (let i = 0, len = this._routes.length; i < len; i++) {
            let item = this._routes[i];
            if (item.path !== "" && item.path !== "/") {
                if (item.hasOwnProperty('data')) {
                    routeIndexes[item.path] = item.data.step;
                }
            }
        }
        this.globalService.calculatorModel.navigationModel.routeIndexes = routeIndexes;

        console.debug('3. routeIndexes: ', routeIndexes);
        console.debug('4. this.globalService.calculatorModel.navigationModel.routeIndexes: ', this.globalService.calculatorModel.navigationModel.routeIndexes);
    }

    get routes(): any {
        return this._routes;
    }

    getRoutePrevious(currentStep: number, device: string = 'all') {
        let previousStep = currentStep - 1;
        let previousRoute = this.routes.find((item) => {
            if (item.hasOwnProperty('data')) {
                return item.data.step === previousStep && item.data.device.indexOf(device) !== -1;
            } else {
                return false;
            }
        });
        if (!previousRoute) {
            return this.getRoutePrevious(previousStep, device);
        } else {
            return previousRoute;
        }
    }

    getRouteNext(currentStep: number, device: string = 'all') {
        let nextStep = currentStep + 1;
        let nextRoute = this.routes.find((item) => {
            if (item.hasOwnProperty('data')) {
                return item.data.step === nextStep && item.data.device.indexOf(device) !== -1;
            } else {
                return false;
            }
        });
        if (!nextRoute) {
            return this.getRouteNext(nextStep, device);
        } else {
            return nextRoute;
        }
    }

    goNext(currentStep: number, device: string = 'all') {
        let nextRoute = this.getRouteNext(currentStep, device);
        if (nextRoute) {
            this.goRoute('/' + this.globalService.calculator.clientCalculator + '/' + nextRoute.path, nextRoute.path);
            this.scrollToTop();
        }
    }

    goBack(currentStep: number, device: string = 'all') {
        let previousRoute = this.getRoutePrevious(currentStep, device);
        if (previousRoute) {
            this.goRoute('/' + this.globalService.calculator.clientCalculator + '/' + previousRoute.path, previousRoute.path);
            this.scrollToTop();
        }
    }

    goBackHistory() {
        this.location.back();
    }

    goRoute(route: string, path: string = null, replaceUrl: boolean = false) {

        // SET THE currentStep on the parent itself after the navigation happens
        // if (path !== null && path !== undefined && path !== "") {
        //     this.currentStep = this.globalService.calculatorModel.navigationModel.routeIndexes[path];
        // }

        console.debug('\n\n1. goRoute(route: string, path: string) ---------- navigation.service 2020-06-12_21:53:24 ----------');
        console.debug('2. route: ', route);
        console.debug('3. path: ', path);

        if (!replaceUrl) {
            this.router.navigate([route]);
        } else {
            // this.router.navigate([route], {replaceUrl: true});
            this.router.navigate([route]);
        }

        this.scrollToTop();
    }

    set currentStep(step: number) {
        this._currentStep = step;
        if (this.globalService.calculatorModel) {
            this.globalService.calculatorModel.navigationModel.previousStep = this.globalService.calculatorModel.navigationModel.currentStep;
            this.globalService.calculatorModel.navigationModel.currentStep = this._currentStep;
        }
    }
    get currentStep() {
        return this._currentStep;
    }

    scrollToTop() {
        // if (this._scrollToTopTimeout) {
        //     clearTimeout(this._scrollToTopTimeout);
        // }
        // this._scrollToTopTimeout = setTimeout((() => {
        //     //DO SOMETHING BELOW
        //     console.debug('\n\n%c1. scrollTop  ----- navigation.service -----', ConsoleColors.HEADING);

        //     document.body.scrollTop = 0; // For Safari
        //     document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        //     this._scrollToTopTimeout = null;
        // }).bind(this), 250);
    }

    scrollTo(el: Element): void {
        console.debug('\n\n%c1. scrollTo  ----- navigation.service -----', ConsoleColors.HEADING);
        console.debug('%c2. scrollTo el', ConsoleColors.HEADING, el);
        if ( el ) {
            console.debug('3. scrollIntoView');
            el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
    }

    // public static defaultTabbingKeydownHandler(e) {

    //     console.debug('\n\n');
    //     console.debug('=========================================================');
    //     console.debug('[-->] navigation.helper => defaultTabbingKeydownHandler(e)');
    //     console.debug('-----------------------------------------------------------');
    //     console.debug('|__ e: ', e);

    //     // let activeElement;
    //     let activeElement = document.activeElement;
    //     let isEventProceeding = true;

    //     if (e && e.keyCode === 9 && !e.shiftKey) {
    //         console.debug('|__ CONDITION TRUE e.keyCode === 9 && && !e.shiftKey ');
    //         // if (activeElement && activeElement.id && activeElement.id === '') {
    //         //     isEventProceeding = false;
    //         // }
    //         // else {
    //         //     if (activeElement.id.indexOf('sidebar_menuitem_') === -1) {
    //         //         isEventProceeding = false;
    //         //     }
    //         // }
    //     }
    //     else if (e && e.keyCode === 9 && e.shiftKey) {
    //         console.debug('|__ CONDITION TRUE e.keyCode === 9 && e.shiftKey ');
    //         // if (activeElement && activeElement.id && activeElement.id === '') {
    //         //     isEventProceeding = false;
    //         // }
    //         // else {
    //         //     if (activeElement.id.indexOf('sidebar_menuitem_') === -1) {
    //         //         isEventProceeding = false;
    //         //     }
    //         //     else {
    //         //         if (activeElement.id === 'sidebar_menuitem_0') {
    //         //             let tabbingRecyclerTop = document.querySelector('.modal-tabbing-recycler-top') as HTMLAnchorElement;
    //         //             if (tabbingRecyclerTop) {
    //         //                 tabbingRecyclerTop.focus();
    //         //                 return false;
    //         //             }
    //         //         }
    //         //     }
    //         // }
    //     }
    //     else {
    //         if (activeElement && activeElement.id && activeElement.id === '') {
    //             isEventProceeding = false;
    //         }
    //         else {
    //             if (activeElement.id.indexOf('sidebar_menuitem_') === -1) {
    //                 isEventProceeding = false;
    //             }
    //         }
    //     }

    //     if (!isEventProceeding) {
    //         console.debug('|__ CANCELLING KEYUP/TABBING EVENT ');
    //         this.focusOnModalFirstOrLastFocusableItem();
    //     }

    //     console.debug('|__ activeElement: ', activeElement);
    //     console.debug('|__ activeElement.id: ', activeElement.id);
    //     console.debug('-----------------------------------------------------------');
    //     console.debug('[<--] navigation.helper => defaultTabbingKeydownHandler(e)');
    //     console.debug('=========================================================');
    //     console.debug('\n\n');

    //     // if this returns FALSE, it means the event has been cancelled like
    //     // event.preventDefault, event.stopPropagation and event.stopImmediatePropagation are invoked
    //     return isEventProceeding;

    // }

}
